<template>
  <div class="form-group">
    <label class="form-label">Страховой продукт*</label>
    <CustomSelect name="maximumProtectionInsuranceProduct" @initialize="onInitialize" @itemSelected="onItemSelected">
      <option data-component="PersonalProtection" value="AccidentInsurance">Страхование от несчастного случая</option>
      <option data-component="BankCardProtection" value="BankCardInsurance">Страхование банковских карт</option>
      <option data-component="WeatherInTheHouse" value="ApartmentInsurance">Страхование квартир</option>
      <option data-component="JobLossInsurance" value="JobLossInsurance">Страхование от потери работы</option>
    </CustomSelect>
  </div>

  <component :is="maximumProtectionComponent"></component>
</template>

<script>
import PersonalProtection from "@/components/insurances/PersonalProtection/PersonalProtection";
import BankCardProtection from "@/components/insurances/BankCardProtection/BankCardProtection";
import WeatherInTheHouse from "@/components/insurances/WeatherInTheHouse/WeatherInTheHouse";
import JobLossInsurance from "@/components/insurances/JobLossInsurance/JobLossInsurance";
import * as mns from "@/store/mutation-types";
import {mapGetters} from "vuex";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "MaximumProtection",
  components: {
    CustomSelect, PersonalProtection,
    BankCardProtection, WeatherInTheHouse,
    JobLossInsurance
  },
  methods: {
    onInitialize(event){
      this.$store.commit(mns.SET_MAXIMUM_PROTECTION_INSURANCE, event.getValue().value);
      this.$store.commit(mns.SET_MAXIMUM_PROTECTION_COMPONENT, event.getValue().customProperties.component);
    },
    onItemSelected(event){
      const choice = event.detail.choice;

      this.$store.commit(mns.SET_MAXIMUM_PROTECTION_INSURANCE, choice.value);
      this.$store.commit(mns.SET_MAXIMUM_PROTECTION_COMPONENT, choice.customProperties.component);
    },
  },
  computed: {
    ...mapGetters(['maximumProtectionComponent',])
  },
}
</script>

<style scoped>

</style>